export enum ButtonSizeType {
  Large = `large`,
  Medium = `medium`,
  Small = `small`,
}
